export default __webpack_public_path__ + "static/media/logoAI.d8b62e42.png";